var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "var(--audio-bg, #EFF1FA)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7594 11.6923C20.2078 11.878 20.5002 12.3156 20.5002 12.8009V27.2009C20.5002 27.6863 20.2078 28.1238 19.7594 28.3096C19.311 28.4953 18.7949 28.3926 18.4517 28.0494L14.0031 23.6009H10.9002C10.2375 23.6009 9.7002 23.0637 9.7002 22.4009V17.6009C9.7002 16.9382 10.2375 16.4009 10.9002 16.4009H14.0031L18.4517 11.9524C18.7949 11.6092 19.311 11.5065 19.7594 11.6923Z",
    fill: "var(--audio-primary, #5A34E1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0884 11.5155C26.557 11.0469 27.3168 11.0469 27.7855 11.5155C29.9557 13.6858 31.3002 16.6874 31.3002 20.0008C31.3002 23.3142 29.9557 26.3158 27.7855 28.4861C27.3168 28.9547 26.557 28.9547 26.0884 28.4861C25.6198 28.0175 25.6198 27.2577 26.0884 26.789C27.827 25.0505 28.9002 22.6521 28.9002 20.0008C28.9002 17.3495 27.827 14.9512 26.0884 13.2126C25.6198 12.744 25.6198 11.9842 26.0884 11.5155ZM22.6943 14.9096C23.1629 14.441 23.9227 14.441 24.3913 14.9096C25.0224 15.5407 25.5374 16.2891 25.9006 17.1204C26.2866 18.004 26.5002 18.979 26.5002 20.0008C26.5002 21.9887 25.693 23.7904 24.3913 25.092C23.9227 25.5606 23.1629 25.5606 22.6943 25.092C22.2257 24.6234 22.2257 23.8636 22.6943 23.3949C23.5642 22.525 24.1002 21.3266 24.1002 20.0008C24.1002 19.3159 23.9575 18.6676 23.7013 18.0813C23.4597 17.5284 23.1164 17.0288 22.6943 16.6067C22.2257 16.1381 22.2257 15.3783 22.6943 14.9096Z",
    fill: "var(--audio-primary, #5A34E1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.234a7ae5f9297d982b76b742802af2e3.svg";
export { ForwardRef as ReactComponent };